module.exports = __webpack_public_path__ + "static/media/image-not-available.ad221be3.png";